// removed by extract-text-webpack-plugin
module.exports = {"filterName":"_32uu9-TGcDaAX9HRPcj30S","carouselContainer":"_1nYaUWGhuib_jyPa-w8CmW","homeContainer":"_1JJMVmRnwrGObYgehPdCAk"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/home/Home.css
// module id = 346
// module chunks = 0